<script lang="ts">
  import PageTitle from "@shared/svelte/Components/PageTitle.svelte";
  import PageWrapper from "@onboarding2/svelte/Signup/PageWrapper.svelte";
  import UserFormWithEmail from "@onboarding2/svelte/Signup/UserFormWithEmail.svelte";
  import type { UserInfo, UserSignUp } from "@shared/types/User";

  export let user: UserSignUp = null;
  export let userInfo: UserInfo = null;
  export let refCode: string = null;
</script>

<PageTitle title="Create your account - Sign up | Provi" />
<PageWrapper {user} {userInfo}>
  <UserFormWithEmail {refCode} />
</PageWrapper>
